import { z } from 'zod';
/**
 * Corps de `POST /chat/feedback` (pouce haut/bas du widget). Remplace la
 * validation manuelle du controller : `traceId` doit être une chaîne non vide
 * et `value` un nombre, le commentaire libre reste facultatif.
 */
export const chatFeedbackSchema = z.object({
    traceId: z.string().min(1),
    comment: z.string().max(2000).optional(),
    value: z.number(),
});
const flightSegmentLocationSchema = z.object({
    category: z.enum(['airport', 'city']),
    iataCode: z.string(),
    label: z.string().optional(),
});
export const structuredMultiSearchSchema = z.object({
    dateRanges: z.array(z.object({ from: z.string(), to: z.string() })).min(1),
    flexibility: z.number().int().min(0).max(3),
    flights: z
        .array(z.object({
        departure: flightSegmentLocationSchema,
        destination: flightSegmentLocationSchema,
    }))
        .min(1),
    passengers: z.object({
        adults: z.number().int().min(0),
        babies: z.number().int().min(0),
        infants: z.number().int().min(0),
        seniors: z.number().int().min(0),
        youngsters: z.number().int().min(0),
    }),
    travelClass: z.enum(['BUSINESS', 'ECONOMY', 'PREMIUM']),
    withLuggage: z.boolean(),
});
